export const dateFormat = 'Do MMMM YYYY h:mm:ssA Z';

export const defaultPageSize = 50;

export const communityList = [
  {
    text: 'NAS_DAILY_CREATOR_COMMUNITY',
    value: 'NAS_DAILY_CREATOR_COMMUNITY'
  }
];

export const sortOrderList = [
  {
    text: 'Newest to Oldest',
    value: '-1'
  },
  {
    text: 'Oldest to Newest',
    value: '1'
  }
];

export const filterList = [
  {
    text: 'Email',
    value: 'email'
  },
  {
    text: 'Name',
    value: 'fullName'
  },
  {
    text: 'Telegram username',
    value: 'telegramUsername'
  }
];

export const applicationStatus = {
  REJECT: 'Rejected',
  APPROVE: 'Approved',
  PENDING: 'Pending',
  CANCELLED: 'Cancelled'
};

export const applicationStatusList = Object.values(applicationStatus).map(
  (key) => ({
    text: key,
    value: key
  })
);

export const reasonToJoinOptions = [
  {
    value: 'learn-form-others',
    label: 'Learn from fellow content creators'
  },
  {
    value: 'build-toolkit',
    label: 'Build a toolkit of tactics to create better content'
  },
  { value: 'find-mentor', label: 'Find mentors who can guide me' },
  {
    value: 'learn-from-videos',
    label: 'Learn from video lessons and live workshops'
  },
  { value: 'other', label: 'Others' }
];

export const restrictedFieldNames = ['_id', 'status', 'subscriptions'];
export const restrictedEditFieldNames = [
  '_id',
  'status',
  'fullName',
  'email',
  'communityCode',
  'communitySignupId',
  'createdAt',
  'updatedAt',
  'statusUpdatedAt',
  'approvedBy',
  'rejectedBy',
  'reviewerNotes'
];
